import { DisplayButtons } from '@/components/DisplayButtons';
import { ELoanUsage, selectLoanUsage } from '@/context/borrower';
import {
    EDisplays,
    EJourneys,
    EModals,
    selectSkipExpenseScreen,
    setDisplay,
    setModal,
} from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { selectIsLoggedIn } from '@/context/user';
import { EConversionType, reportConversion } from '@/utils/reportConversion';
import { EParameters, getParameters } from '@/utils/setParametersFromParams';

interface servicingSuccessProps {
    baseId: string;
}

export function ServicingSuccessButtons({
    baseId,
}: servicingSuccessProps): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const loanUsage = useAppSelector(selectLoanUsage);
    const skipExpenseScreen = useAppSelector(selectSkipExpenseScreen);
    const params = getParameters();

    // ***** Event Handlers *****
    function handleBackClick(): void {
        const backScreen = getBackScreen();
        dispatch(setDisplay(backScreen));
    }

    function handleNextClick(): void {
        const paramJourney = params.get(EParameters.INITIAL_JOURNEY);

        if (paramJourney?.toLocaleUpperCase() === EJourneys.TEST_DRIVE) {
            dispatch(setDisplay(EDisplays.PREPPROVAL_ANIMATION));
            return;
        }
        const nextModal = getNextModal();
        const nextDisplay = getNextDisplay();
        reportConversion(EConversionType.INSTANT_PRE_APPROVAL);
        if (loanUsage !== ELoanUsage.NOVATED) {
            if (nextModal) {
                dispatch(setModal(nextModal));
            }
        }
        if (loanUsage === ELoanUsage.NOVATED) {
            dispatch(setModal(EModals.WORK_HISTORY));
            dispatch(setDisplay(EDisplays.EMPLOYMENT));
            return;
        }
        if (nextDisplay) {
            dispatch(setDisplay(nextDisplay));
        }
    }

    // ***** Helpers ******
    function getBackScreen(): EDisplays {
        if (skipExpenseScreen) return EDisplays.INCOME;
        return EDisplays.EXPENSE;
    }

    function getNextModal(): EModals | void {
        if (!isLoggedIn) {
            return EModals.REGISTER;
        }
        // T&C is now handled during login/registration via TermsAndConditions component
        // No need to show EXPRESS_PRIVACY modal
    }

    function getNextDisplay(): EDisplays | void {
        if (isLoggedIn) {
            return EDisplays.IDENTIFICATION;
        }
        return;
    }

    return (
        <DisplayButtons
            idLeftButton={`${baseId}-button-back`}
            idRightButton={`${baseId}-button-next`}
            rightClick={handleNextClick}
            leftClick={handleBackClick}
        />
    );
}
